var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mb-5"},[_c('span',{staticClass:"display-4 col-12"},[_vm._v(" "+_vm._s(`${_vm.importation.name}`)+" - "+_vm._s(_vm.$t("IMPORTS.RESULTS"))+" ")])]),_c('import-results',{attrs:{"hasStatus":_vm.importation.linkedObject,"importResults":_vm.importation.results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }